import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    autosuggestOwnIbansOnly: true,
    accountNameMatchString:
        /^[\w áßäčćďđéěíĺľňóöőôřŕšťúůüűýžÁÄČĆĎĐÉĚÍĹĽŇÓÖŐÔŘŔŠŤÚŮÜŰÝŽ-]+$/.toString(),
    sendAccountNumberWithPut: true,
    accountNameMinimumLength: 1,
    isJuniorAliasChangeAllowed: true,
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
